import { render } from "./RegistrationModal.vue?vue&type=template&id=2fe5791c&scoped=true"
import script from "./RegistrationModal.vue?vue&type=script&lang=js"
export * from "./RegistrationModal.vue?vue&type=script&lang=js"

import "./RegistrationModal.vue?vue&type=style&index=0&id=2fe5791c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe5791c"]])

export default __exports__